import { useMemo } from 'react';
import '../../../assets/socialMedia/facebook.svg.mjs';
import '../../../assets/socialMedia/instagram.svg.mjs';
import '../../../assets/socialMedia/x.svg.mjs';
import '../../../assets/socialMedia/youtube.svg.mjs';
import { ExternalUrl } from '../../../constants/url.mjs';
import '../../../contexts/MenuContext/index.mjs';
import { SiteId } from '../../../contexts/MenuContext/mapping.mjs';
import '../../../hooks/index.mjs';
import '../../../types/index.mjs';
import { isNonNullish } from '../../../utils/typeGuards.mjs';
import EN_TRANSLATION from '../translations/en.json.mjs';
import { StoreId } from '../../../types/generated.mjs';
import { useMenu } from '../../../contexts/MenuContext/context.mjs';
import { useTranslation } from '../../../hooks/useTranslation.mjs';
import { Language } from '../../../types/constants.mjs';
import FacebookIcon__default from "../../../assets/facebook.svg";
import XIcon__default from "../../../assets/x.svg";
import YoutubeIcon__default from "../../../assets/youtube.svg";
import InstagramIcon__default from "../../../assets/instagram.svg";
"use strict";
var FooterHeaderId = /* @__PURE__ */(FooterHeaderId2 => {
  FooterHeaderId2["Company"] = "company";
  FooterHeaderId2["Training"] = "training";
  FooterHeaderId2["Buy"] = "buy";
  FooterHeaderId2["Tools"] = "tools";
  FooterHeaderId2["Social"] = "social";
  FooterHeaderId2["Terms"] = "terms";
  return FooterHeaderId2;
})(FooterHeaderId || {});
var FooterLinkId = /* @__PURE__ */(FooterLinkId2 => {
  FooterLinkId2["Careers"] = "careers";
  FooterLinkId2["Contact"] = "contact";
  FooterLinkId2["Investors"] = "investors";
  FooterLinkId2["Courses"] = "courses";
  FooterLinkId2["Calendar"] = "calendar";
  FooterLinkId2["Trainers"] = "trainers";
  FooterLinkId2["BecomeTrainer"] = "becomeTrainer";
  FooterLinkId2["FindDistributor"] = "findDistributor";
  FooterLinkId2["BecomeDistributor"] = "becomeDistributor";
  FooterLinkId2["DesignCenter"] = "designCenter";
  FooterLinkId2["WiFiman"] = "wifiman";
  FooterLinkId2["UISP"] = "uisp";
  FooterLinkId2["UispDesignCenter"] = "uispDesignCenter";
  FooterLinkId2["Facebook"] = "facebook";
  FooterLinkId2["X"] = "x";
  FooterLinkId2["Youtube"] = "youtube";
  FooterLinkId2["Instagram"] = "instagram";
  FooterLinkId2["Conditions"] = "conditions";
  FooterLinkId2["Service"] = "service";
  FooterLinkId2["Privacy"] = "privacy";
  FooterLinkId2["Return"] = "return";
  FooterLinkId2["Cookie"] = "cookie";
  FooterLinkId2["Legal"] = "legal";
  FooterLinkId2["Store"] = "store";
  FooterLinkId2["Faq"] = "faq";
  FooterLinkId2["Downloads"] = "downloads";
  FooterLinkId2["Compliance"] = "compliance";
  FooterLinkId2["Blog"] = "blog";
  FooterLinkId2["CaseStudies"] = "caseStudies";
  FooterLinkId2["TrustCenter"] = "trustCenter";
  FooterLinkId2["Support"] = "support";
  FooterLinkId2["WhatsNew"] = "whats-new";
  return FooterLinkId2;
})(FooterLinkId || {});
const FOOTER_LINKS = {
  ["careers" /* Careers */]: ExternalUrl.CAREERS,
  ["contact" /* Contact */]: ExternalUrl.CONTACT,
  ["investors" /* Investors */]: ExternalUrl.INVESTORS,
  ["courses" /* Courses */]: ExternalUrl.COURSES,
  ["calendar" /* Calendar */]: ExternalUrl.CALENDAR,
  ["trainers" /* Trainers */]: ExternalUrl.PARTNERS,
  ["becomeTrainer" /* BecomeTrainer */]: ExternalUrl.TRAINERS,
  ["findDistributor" /* FindDistributor */]: ExternalUrl.FIND_DISTRIBUTOR,
  ["becomeDistributor" /* BecomeDistributor */]: ExternalUrl.BECOME_DISTRIBUTOR,
  ["designCenter" /* DesignCenter */]: ExternalUrl.DESIGN_CENTER,
  ["wifiman" /* WiFiman */]: ExternalUrl.WIFIMAN,
  ["uisp" /* UISP */]: ExternalUrl.UISP,
  ["uispDesignCenter" /* UispDesignCenter */]: ExternalUrl.UISP_DESIGN_CENTER,
  ["facebook" /* Facebook */]: ExternalUrl.FACEBOOK,
  ["x" /* X */]: ExternalUrl.X,
  // Twitter
  ["youtube" /* Youtube */]: ExternalUrl.YOUTUBE,
  ["instagram" /* Instagram */]: ExternalUrl.INSTAGRAM,
  ["service" /* Service */]: ExternalUrl.TERMS_SERVICE,
  ["return" /* Return */]: ExternalUrl.RETURN_POLICY,
  ["compliance" /* Compliance */]: ExternalUrl.COMPLIANCE
};
const TOC_LINKS = {
  [StoreId.Ca]: "https://www.ui.com/legal/ui-ca-store/termsandconditions/",
  [StoreId.Us]: "https://www.ui.com/legal/ui-store/termsandconditions/",
  [StoreId.Eu]: "https://www.ui.com/legal/ui-eu-store/termsandconditions/",
  [StoreId.Za]: "https://www.ui.com/legal/ui-za-store/termsandconditions/",
  [StoreId.Me]: "https://www.ui.com/legal/ui-me-store/termsandconditions/",
  [StoreId.Uk]: "https://www.ui.com/legal/ui-uk-store/termsandconditions/",
  [StoreId.In]: "https://www.ui.com/legal/ui-in-store/termsandconditions/",
  [StoreId.Sg]: "https://www.ui.com/legal/ui-sg-store/termsandconditions/",
  [StoreId.Br]: "https://www.ui.com/legal/ui-br-store/termsandconditions/",
  [StoreId.Mx]: "https://www.ui.com/legal/ui-mx-store/termsandconditions/",
  [StoreId.Jp]: "https://www.ui.com/legal/ui-jp-store/termsandconditions/",
  [StoreId.Tw]: "https://www.ui.com/legal/ui-tw-store/termsandconditions/",
  [StoreId.Ph]: "https://www.ui.com/legal/ui-ph-store/termsandconditions/",
  [StoreId.Cn]: "https://www.ui.com.cn/legal/ui-store/termsandconditions/"
};
const CONTACT_LINKS = {
  [StoreId.Us]: ExternalUrl.CONTACT,
  [StoreId.Tw]: "https://tw.ui.com/contact/"
};
const BECOME_DISTRIBUTOR_LINKS = {
  [StoreId.Us]: ExternalUrl.BECOME_DISTRIBUTOR,
  [StoreId.Tw]: "https://tw.ui.com/distributors/become-authorized-distributor/"
};
const TOS_LINKS = {
  [StoreId.Us]: ExternalUrl.TERMS_SERVICE,
  [StoreId.Cn]: "https://www.ui.com.cn/legal/termsofservice/"
};
const PRIVACY_POLICY_LINKS = {
  [StoreId.Us]: ExternalUrl.PRIVACY_POLICY,
  [StoreId.Cn]: "https://www.ui.com.cn/legal/privacypolicy/"
};
const FACEBOOK_LINKS = {
  [StoreId.Us]: ExternalUrl.FACEBOOK,
  [StoreId.Jp]: "https://www.facebook.com/UbiquitiJapan"
};
const getRegionalLink = (links, storeId = StoreId.Us) => {
  const link = links[storeId];
  if (link) {
    return link;
  }
  return links[StoreId.Us];
};
const useFooterContent = () => {
  const {
    storeId,
    context,
    createSiteUrl
  } = useMenu();
  const {
    formatMessage
  } = useTranslation({
    defaultTranslation: EN_TRANSLATION,
    additionalTranslations: {
      [Language.Ar]: () => import('../translations/ar.json.mjs').then(res => res.default),
      [Language.Ca]: () => import('../translations/ca.json.mjs').then(res => res.default),
      [Language.Cs]: () => import('../translations/cs.json.mjs').then(res => res.default),
      [Language.Da]: () => import('../translations/da.json.mjs').then(res => res.default),
      [Language.Nl]: () => import('../translations/nl.json.mjs').then(res => res.default),
      [Language.Fr]: () => import('../translations/fr.json.mjs').then(res => res.default),
      [Language.De]: () => import('../translations/de.json.mjs').then(res => res.default),
      [Language.El]: () => import('../translations/el.json.mjs').then(res => res.default),
      [Language.It]: () => import('../translations/it.json.mjs').then(res => res.default),
      [Language.Ja]: () => import('../translations/ja.json.mjs').then(res => res.default),
      [Language.Ko]: () => import('../translations/ko.json.mjs').then(res => res.default),
      [Language.No]: () => import('../translations/no.json.mjs').then(res => res.default),
      [Language.Pl]: () => import('../translations/pl.json.mjs').then(res => res.default),
      [Language.PtPt]: () => import('../translations/pt-PT.json.mjs').then(res => res.default),
      [Language.EsMx]: () => import('../translations/es-MX.json.mjs').then(res => res.default),
      [Language.Sv]: () => import('../translations/sv.json.mjs').then(res => res.default),
      [Language.Tr]: () => import('../translations/tr.json.mjs').then(res => res.default),
      [Language.Zh]: () => import('../translations/zh-Hans.json.mjs').then(res => res.default),
      [Language.Tw]: () => import('../translations/zh-Hant-TW.json.mjs').then(res => res.default),
      [Language.PtBr]: () => import('../translations/pt-BR.json.mjs').then(res => res.default),
      [Language.Ru]: () => import('../translations/ru.json.mjs').then(res => res.default),
      [Language.EsEs]: () => import('../translations/es-ES.json.mjs').then(res => res.default)
    }
  });
  const urls = useMemo(() => {
    return {
      termsAndConditions: getRegionalLink(TOC_LINKS, storeId),
      privacyPolicy: getRegionalLink(PRIVACY_POLICY_LINKS, storeId)
    };
  }, [storeId]);
  const footerContent = useMemo(() => ({
    company: {
      header: {
        id: "company" /* Company */,
        label: formatMessage("footer.header.company")
      },
      items: [{
        id: "blog" /* Blog */,
        label: formatMessage("footer.link.blog"),
        src: createSiteUrl([SiteId.Blog, "/"]),
        target: "_blank"
      }, {
        id: "caseStudies" /* CaseStudies */,
        label: formatMessage("footer.link.caseStudies"),
        src: createSiteUrl([SiteId.CaseStudies, "/"]),
        target: "_blank"
      }, {
        id: "careers" /* Careers */,
        label: formatMessage("footer.link.careers"),
        src: FOOTER_LINKS["careers" /* Careers */],
        target: "_blank"
      }, {
        id: "trustCenter" /* TrustCenter */,
        label: formatMessage("footer.link.trustCenter"),
        src: createSiteUrl([SiteId.Ui, "/trust-center"]),
        target: "_blank"
      }, {
        id: "contact" /* Contact */,
        label: formatMessage("footer.link.contact"),
        src: getRegionalLink(CONTACT_LINKS, storeId),
        target: "_blank"
      }, {
        id: "investors" /* Investors */,
        label: formatMessage("footer.link.investors"),
        src: FOOTER_LINKS["investors" /* Investors */],
        target: "_blank"
      }, {
        id: "compliance" /* Compliance */,
        label: formatMessage("footer.link.compliance"),
        src: FOOTER_LINKS["compliance" /* Compliance */],
        target: "_blank"
      }].filter(isNonNullish)
    },
    training: {
      header: {
        id: "training" /* Training */,
        label: formatMessage("footer.header.training")
      },
      items: [{
        id: "courses" /* Courses */,
        label: formatMessage("footer.link.courses"),
        src: FOOTER_LINKS["courses" /* Courses */],
        target: "_blank"
      }, {
        id: "calendar" /* Calendar */,
        label: formatMessage("footer.link.calendar"),
        src: FOOTER_LINKS["calendar" /* Calendar */],
        target: "_blank"
      }, {
        id: "trainers" /* Trainers */,
        label: formatMessage("footer.link.trainers"),
        src: FOOTER_LINKS["trainers" /* Trainers */],
        target: "_blank"
      }, {
        id: "becomeTrainer" /* BecomeTrainer */,
        label: formatMessage("footer.link.becomeTrainer"),
        src: FOOTER_LINKS["becomeTrainer" /* BecomeTrainer */],
        target: "_blank"
      }].filter(isNonNullish)
    },
    buy: {
      header: {
        id: "buy" /* Buy */,
        label: formatMessage("footer.header.buy")
      },
      items: [context !== SiteId.Store ? {
        id: "store" /* Store */,
        label: formatMessage("footer.link.store"),
        src: createSiteUrl([SiteId.Store, "/"]),
        target: "_blank"
      } : null, {
        id: "findDistributor" /* FindDistributor */,
        label: formatMessage("footer.link.distributor.find"),
        src: FOOTER_LINKS["findDistributor" /* FindDistributor */],
        target: "_blank"
      }, {
        id: "becomeDistributor" /* BecomeDistributor */,
        label: formatMessage("footer.link.distributor.become"),
        src: getRegionalLink(BECOME_DISTRIBUTOR_LINKS, storeId),
        target: "_blank"
      }].filter(isNonNullish)
    },
    tools: {
      header: {
        id: "tools" /* Tools */,
        label: formatMessage("footer.header.tools")
      },
      items: [{
        id: "wifiman" /* WiFiman */,
        label: formatMessage("footer.link.wifiman"),
        src: FOOTER_LINKS["wifiman" /* WiFiman */],
        target: "_blank"
      }, {
        id: "uisp" /* UISP */,
        label: formatMessage("footer.link.uisp"),
        src: FOOTER_LINKS["uisp" /* UISP */],
        target: "_blank"
      }, {
        id: "designCenter" /* DesignCenter */,
        label: formatMessage("footer.link.designCenter"),
        src: FOOTER_LINKS["designCenter" /* DesignCenter */],
        target: "_blank"
      }, {
        id: "uispDesignCenter" /* UispDesignCenter */,
        label: formatMessage("footer.link.uispDesignCenter"),
        src: FOOTER_LINKS["uispDesignCenter" /* UispDesignCenter */],
        target: "_blank"
      }, {
        id: "downloads" /* Downloads */,
        label: formatMessage("footer.link.downloads"),
        src: ExternalUrl.UI_DOWNLOADS,
        target: "_blank"
      }].filter(isNonNullish)
    }
  }), [context, createSiteUrl, formatMessage, storeId]);
  const socialContent = useMemo(() => ({
    header: {
      id: "social" /* Social */,
      label: formatMessage("footer.header.social")
    },
    items: [{
      id: "facebook" /* Facebook */,
      label: "Facebook",
      src: getRegionalLink(FACEBOOK_LINKS, storeId),
      icon: FacebookIcon__default,
      target: "_blank"
    }, {
      id: "x" /* X */,
      label: "X",
      src: FOOTER_LINKS["x" /* X */],
      icon: XIcon__default,
      target: "_blank"
    }, {
      id: "youtube" /* Youtube */,
      label: "Youtube",
      src: FOOTER_LINKS["youtube" /* Youtube */],
      icon: YoutubeIcon__default,
      target: "_blank"
    }, {
      id: "instagram" /* Instagram */,
      label: "Instagram",
      src: FOOTER_LINKS["instagram" /* Instagram */],
      icon: InstagramIcon__default,
      target: "_blank"
    }].filter(isNonNullish)
  }), [formatMessage, storeId]);
  const termsContent = useMemo(() => ({
    header: {
      id: "terms" /* Terms */,
      label: formatMessage("footer.header.terms")
    },
    items: [
    // Show "Terms and Conditions" only on store
    context === SiteId.Store ? {
      id: "conditions" /* Conditions */,
      label: formatMessage("footer.link.terms.conditions"),
      src: urls.termsAndConditions,
      target: "_blank"
    } : null, {
      id: "service" /* Service */,
      label: formatMessage("footer.link.terms.service"),
      src: getRegionalLink(TOS_LINKS, storeId),
      target: "_blank"
    }, {
      id: "privacy" /* Privacy */,
      label: formatMessage("footer.link.terms.policy.privacy"),
      src: urls.privacyPolicy,
      target: "_blank"
    },
    // Show "Legal" only on non-store sites
    context !== SiteId.Store ? {
      id: "legal" /* Legal */,
      label: formatMessage("footer.link.legal"),
      src: "https://www.ui.com/legal/",
      target: "_blank"
    } : null,
    // Show "Return Policy" only on store
    context === SiteId.Store ? {
      id: "return" /* Return */,
      label: formatMessage("footer.link.terms.policy.return"),
      src: urls.termsAndConditions,
      target: "_blank"
    } : null, {
      id: "cookie" /* Cookie */,
      label: formatMessage("footer.link.terms.cookie"),
      src: ""
    },
    // Show "FAQ" only on store and not China store
    context === SiteId.Store && storeId !== StoreId.Cn ? {
      id: "faq" /* Faq */,
      label: formatMessage("footer.link.terms.faq"),
      src: createSiteUrl([SiteId.Store, "/faq"]),
      target: "_blank"
    } : null].filter(isNonNullish)
  }), [context, createSiteUrl, formatMessage, storeId, urls.privacyPolicy, urls.termsAndConditions]);
  const DEFAULT_LINKS = [{
    id: "whats-new" /* WhatsNew */,
    label: formatMessage("footer.whats-new"),
    src: createSiteUrl([SiteId.Ui, "/whats-new"]),
    items: []
  }, {
    id: "support" /* Support */,
    label: formatMessage("footer.support"),
    src: ExternalUrl.SUPPORT,
    items: [],
    target: "_blank"
  }];
  return {
    footerContent,
    socialContent,
    termsContent,
    urls,
    miscLinks: DEFAULT_LINKS
  };
};
const COOKIE_POLICY_BTN_ID = "ot-sdk-btn";
const COOKIE_POLICY_BTN_ID_CLASSNAME = "ot-sdk-show-settings";
export { COOKIE_POLICY_BTN_ID, COOKIE_POLICY_BTN_ID_CLASSNAME, FOOTER_LINKS, FooterHeaderId, FooterLinkId, useFooterContent };
//# sourceMappingURL=useFooterContent.mjs.map
